import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";

import LoginPage from "@view/auth/LoginPage";
import ResetPasswordPage from "@view/auth/ResetPasswordPage";
import { NotFound } from "@view/NotFound";
import { ProfileNew } from "@view/user/base_user/ProfileNew.jsx";
import { StatementHistory } from "@view/user/StatementHistory.jsx";
import { Logout } from "@view/user/base_user/Logout";
import { Landing } from "@view/admin/Landing";
import { useAuth } from "@components/context/AuthContext";
import Sidebar from "@components/constant_components/Sidebar";

import RegistrationRoutes from "@routes/RegistrationRoutes";
import RBACRoutes from "@routes/RBACRoutes";
import RBACNav from "./RBACNav";
import { INavItens } from "@interfaces/INavItens";
import BuildersLogo from "@components/BuildersLogo";
import { getUserInitials } from "@utils/general";
import UserAccountModal from "@view/auth/UserAccountModal";
import { useTranslation } from "react-i18next";

export function AppRoutes() {
  const { user, getInfo, hasPermission } = useAuth();
  const { i18n } = useTranslation();

  const [navBar, setNavBar] = useState([] as INavItens[]);
  const [logged, setLogged] = useState(false);
  const [userType, setUserType] = useState("");
  const [userInitials, setUserInitials] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userName, setUserName] = useState("");
  useEffect(() => {
    async function fetchInfo() {
      const result = await getInfo();
      if (result.roles === undefined || result.userType === undefined) {
        setLogged(false);
        // navigate("/landing")
        return;
      }

      setLogged(true);
      setUserType(result.userType);
      setUserInitials(getUserInitials(result.user_name || ""));
      setUserName(result.user_name || "");

      const navItens = await RBACNav(result, hasPermission, user);
      setNavBar(navItens);
    }
    fetchInfo();
  }, [getInfo, hasPermission, user, i18n.language]);

  return (
    <>
      {!!logged && <Sidebar prop={navBar} />}
      <div className="tw-flex tw-flex-col tw-h-screen tw-w-screen tw-overflow-hidden">
        {!!logged && (
          <div className="tw-flex tw-justify-between tw-items-center tw-bg-white tw-p-1 tw-border-b-[1.5px] tw-border-gray-300 tw-flex-shrink-0">
            <BuildersLogo className="tw-ml-14 !tw-h-11 !tw-w-17" />
            <button
              onClick={() => setIsModalOpen(true)}
              className="tw-rounded-full tw-border tw-bg-gray-100 tw-p-2 tw-mr-4 tw-w-10 tw-h-10 tw-align-center tw-flex tw-justify-center hover:tw-bg-gray-300"
            >
              {userInitials}
            </button>
          </div>
        )}

        <UserAccountModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          userInitials={userInitials}
          userName={userName}
        />

        <div className="tw-bg-gray-100 tw-flex-1 tw-overflow-auto tw-p-0">
          <Routes>
            {/* Public Routes */}
            <Route index element={<Landing />} />
            <Route path="/login/:type" element={<LoginPage />} />
            <Route
              path="/resetpassword/:type/:encrypted_code"
              element={<ResetPasswordPage />}
            />
            {/* Admin Routes */}
            <Route path="/landing" element={<Landing />} />

            {RBACRoutes()}

            {/* Contractor Portal Protected Routes */}
            <Route path="/contractor/:id" element={<ProfileNew />} />
            <Route
              path="/contractor/:id/statement-history"
              element={<StatementHistory />}
            />
            {userType !== "admin" && userType !== "super_admin"
              ? RegistrationRoutes()
              : null}
            <Route path="/logout" element={<Logout />} />
            {/* 404 Not Found Route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </div>
    </>
  );
}
